import { render } from "./Success.layout.vue?vue&type=template&id=40ed3436"
import script from "./Success.layout.vue?vue&type=script&lang=js"
export * from "./Success.layout.vue?vue&type=script&lang=js"

import "./Success.layout.vue?vue&type=style&index=0&id=40ed3436&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__